import { render, staticRenderFns } from "./Index1.vue?vue&type=template&id=39f80fe4&scoped=true"
import script from "./Index1.vue?vue&type=script&lang=js"
export * from "./Index1.vue?vue&type=script&lang=js"
import style0 from "./Index1.vue?vue&type=style&index=0&id=39f80fe4&prod&scoped=true&lang=css"
import style1 from "./Index1.vue?vue&type=style&index=1&id=39f80fe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f80fe4",
  null
  
)

export default component.exports